import { useEffect, useState } from "react";
import { getPosts, WPPost } from "../content/contentClient";

type UseWPPostsResult = {
  posts: WPPost[];
  loading: boolean;
  error: boolean;
};

export default function useWPPosts(perPage = 12, lang?: string): UseWPPostsResult {
  const [posts, setPosts] = useState<WPPost[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;

    const load = async () => {
      setLoading(true);
      setError(false);
      try {
        const data = await getPosts(perPage, lang);
        if (active) setPosts(data || []);
      } catch {
        if (active) {
          setError(true);
          setPosts([]);
        }
      } finally {
        if (active) setLoading(false);
      }
    };

    load();
    return () => {
      active = false;
    };
  }, [perPage, lang]);

  return { posts, loading, error };
}
